/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';

export type ConversationPublishSlotStoreData = Partial<OmitFunctions<ConversationPublishSlotStore>>;

export class ConversationPublishSlotStore {
    @observable public versionId: string;

    @observable public isStaging: boolean;

    @observable public isSentimentAnalysisOn: boolean;

    @observable public isSpeechPrimingOn: boolean;

    @observable public lastPublishedDate: Date;

    constructor(slotData: ConversationPublishSlotStoreData) {
        this.versionId = slotData.versionId;
        this.isStaging = slotData.isStaging;
        this.isSentimentAnalysisOn = slotData.isSentimentAnalysisOn || false;
        this.isSpeechPrimingOn = slotData.isSpeechPrimingOn || false;
        this.lastPublishedDate = slotData.lastPublishedDate;
    }

    /**
     * Updates name of the model.
     * @param name new name for the model
     */
    @action
    public setLastPublishedDate(lastPublishedDate: Date) {
        this.lastPublishedDate = lastPublishedDate;
    }
}
